export const allFoldersInSharedMailbox = "edYyNd";
export const allFoldersInPstFile = "ikFWD";
export default {allFoldersInSharedMailbox,allFoldersInPstFile};